import React from "react";
import PropTypes from "prop-types";

class FilterForm extends React.Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        const checked = event.target.checked,
            btns = document.querySelectorAll(".filter__btn"),
            checks = document.querySelectorAll(".filter__list .filter__check"),
            isDisabled = [].filter.call(checks, function(el) {
                return !el.checked;
            });

        if (checks.length == isDisabled.length) {
            for (let i = 0, l = btns.length; i < l; i++) {
                btns[i].classList.remove("is-active");
            }
        } else {
            for (let i = 0, l = btns.length; i < l; i++) {
                btns[i].classList.add("is-active");
            }
        }
    }

    handleSubmit(event) {
        event.preventDefault();
        const app = document.querySelector(".appetite__grid"),
            strong = document.querySelectorAll(".app--strong"),
            qualified = document.querySelectorAll(".app--qualified"),
            //mixed = document.querySelectorAll('.app--mixed'),
            limited = document.querySelectorAll(".app--limited"),
            na = document.querySelectorAll(".app-na"),
            //filter = document.querySelectorAll('.filter__btn'),
            // submit = document.querySelectorAll('.filter__btn--submit'),
            list = app.classList,
            items = document.querySelectorAll(".grid__list .grid__item"),
            selection = [];
        list.remove("strong");
        list.remove("qualified");
        //list.remove('mixed');
        list.remove("limited");
        list.remove("na");
        list.remove("is-active");
        list.toggle("is-filtered");

        // Reset grid striping
        for (let i = 0, l = items.length; i < l; i++) {
            items[i].classList.remove("is-active");
            items[i].classList.remove("gray-bg");
            items[i].classList.remove("white-bg");
        }

        if (
            (this.refs.strongDesk && this.refs.strongDesk.checked) ||
            (this.refs.strongMob && this.refs.strongMob.checked)
        ) {
            selection.push("Strong Appetite");
            list.add("strong");
            if (strong.length > 1) {
                for (let i = 0, l = strong.length; i < l; i++) {
                    strong[i].classList.add("is-active");
                }
            }
        }

        if (
            (this.refs.qualifiedDesk && this.refs.qualifiedDesk.checked) ||
            (this.refs.qualifiedMob && this.refs.qualifiedMob.checked)
        ) {
            selection.push("Qualified Appetite");
            list.add("qualified");
            if (qualified.length > 1) {
                for (let i = 0, l = qualified.length; i < l; i++) {
                    qualified[i].classList.add("is-active");
                }
            }
        }

        // if (this.refs.mixedDesk.checked || this.refs.mixedMob.checked) {
        //     selection.push('Mixed Appetite');
        //     list.add('mixed');
        //     if (mixed.length > 1) {
        //        for (let i = 0, l = mixed.length; i < l; i++) {
        //             mixed[i].classList.add('is-active');
        //         }
        //     }
        // }

        if (
            (this.refs.limitedDesk && this.refs.limitedDesk.checked) ||
            (this.refs.limitedMob && this.refs.limitedMob.checked)
        ) {
            selection.push("Limited or No Appetite");
            list.add("limited");
            if (limited.length > 1) {
                for (let i = 0, l = limited.length; i < l; i++) {
                    limited[i].classList.add("is-active");
                }
            }
        }

        if (
            (this.refs.naDesk && this.refs.naDesk.checked) ||
            (this.refs.naMob && this.refs.naMob.checked)
        ) {
            selection.push("Not-Available");
            list.add("na");
            if (na.length > 1) {
                for (let i = 0, l = na.length; i < l; i++) {
                    na[i].classList.add("is-active");
                }
            }
        }

        const active = document.querySelectorAll(
            ".grid__list .grid__item.is-active"
        );

        for (let i = 0, l = active.length; i < l; i++) {
            if (i % 2 === 0) {
                active[i].classList.add("gray-bg");
            } else {
                active[i].classList.add("white-bg");
            }
        }

        this.props.toggleFilter();

        // GTM Event
        window.dataLayer.push({
            event: "filter",
            filter: selection
        });
    }

    handleReset(event) {
        // Reset page
        event.preventDefault();
        const app = document.querySelector(".appetite__grid"),
            list = app.classList,
            filters = document.querySelectorAll(
                '.filter__list input[type="checkbox"]'
            ),
            btns = document.querySelectorAll(".filter__btn"),
            active = document.querySelectorAll(
                ".grid__list .grid__item.is-active"
            );
        list.remove("strong");
        list.remove("qualified");
        //list.remove('mixed');
        list.remove("limited");
        list.remove("na");
        list.remove("is-active");

        // Reset checks
        for (let i = 0, l = filters.length; i < l; i++) {
            if (filters[i].checked === true) {
                filters[i].click();
            }
        }

        // Reset btns
        for (let i = 0, l = btns.length; i < l; i++) {
            btns[i].classList.remove("is-active");
        }

        // Reset grid striping
        for (let i = 0, l = active.length; i < l; i++) {
            active[i].classList.remove("is-active");
            active[i].classList.remove("gray-bg");
            active[i].classList.remove("white-bg");
        }
    }

    render() {
        return (
            <aside className="appetite__helpers">
                <form
                    onSubmit={this.handleSubmit}
                    className="filter"
                    role="form"
                >
                    <legend
                        className="filter__tab"
                        onClick={this.props.toggleFilter}
                    >
                        Filter &nbsp;
                        <i className="fas fa-chevron-down" />
                    </legend>
                    <fieldset className="filter__fields">
                        <dl className="filter__list">
                            <dt className="grid__item app--strong">
                                <input
                                    ref={`strong${this.props.formMode}`}
                                    type="checkbox"
                                    id={`strong${this.props.formMode}`}
                                    name={`strong${this.props.formMode}`}
                                    className="filter__check"
                                    onChange={this.handleChange}
                                />
                                <label
                                    htmlFor={`strong${this.props.formMode}`}
                                    className="filter__label"
                                >
                                    Strong Appetite
                                </label>
                            </dt>
                            <dt className="grid__item app--qualified">
                                <input
                                    type="checkbox"
                                    ref={`qualified${this.props.formMode}`}
                                    id={`qualified${this.props.formMode}`}
                                    name={`qualified${this.props.formMode}`}
                                    className="filter__check"
                                    onChange={this.handleChange}
                                />
                                <label
                                    htmlFor={`qualified${this.props.formMode}`}
                                    className="filter__label"
                                >
                                    Qualified; each risk considered on its
                                    merits
                                </label>
                            </dt>
                            {/* <dt className="grid__item app--mixed">
                                <input
                                    type="checkbox"
                                    ref={`mixed${this.props.formMode}`}
                                    id={`mixed${this.props.formMode}`}
                                    name={`mixed${this.props.formMode}`}
                                    className="filter__check"
                                    onChange={this.handleChange}
                                />
                                <label htmlFor={`mixed${this.props.formMode}`} className="filter__label">Qualified; <em className="label-sm">GL+ Product = Green</em></label>
                            </dt>*/}
                            <dt className="grid__item app--limited">
                                <input
                                    type="checkbox"
                                    ref={`limited${this.props.formMode}`}
                                    id={`limited${this.props.formMode}`}
                                    name={`limited${this.props.formMode}`}
                                    className="filter__check"
                                    onChange={this.handleChange}
                                />
                                <label
                                    htmlFor={`limited${this.props.formMode}`}
                                    className="filter__label"
                                >
                                    Limited or No Appetite
                                </label>
                            </dt>
                            <dt className="grid__item app--na">
                                <input
                                    type="checkbox"
                                    ref={`na${this.props.formMode}`}
                                    id={`na${this.props.formMode}`}
                                    name={`na${this.props.formMode}`}
                                    className="filter__check"
                                    onChange={this.handleChange}
                                />
                                <label
                                    htmlFor={`na${this.props.formMode}`}
                                    className="filter__label"
                                >
                                    N/A
                                </label>
                            </dt>
                        </dl>
                        <section className="filter__btn-wrap">
                            <button
                                className="filter__btn filter__btn--reset"
                                onClick={this.handleReset}
                                type="reset"
                            >
                                Reset
                            </button>
                            <button
                                className="filter__btn filter__btn--submit"
                                type="submit"
                            >
                                Apply
                            </button>
                        </section>
                    </fieldset>
                </form>
            </aside>
        );
    }
}

export default FilterForm;



// WEBPACK FOOTER //
// ./src/components/FilterForm.js